import { AnyAction } from 'redux';

interface MessageState {
    text: string
    status: string
    display: string
    scrollTop: boolean
}

const noMessage: MessageState = {
    text: '',
    status: '',
    display: 'onNavigate',
    scrollTop: false
};

const message = (state : MessageState = noMessage, action: AnyAction) => {
    switch (action.type) {
        case 'SET_MESSAGE':
          
            const newState = {
                text: action.text,
                status: action.status,
                display: action.display,
                scrollTop: action.scrollTop
            }

            return {
                ...state,
                ...newState
            }
            
        default:
            return state
    }
}
  
  export default message;